package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import migrations.VesselTable

public class VesselTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getAllVessel(mapper: (id: String, name: String) -> T): Query<T> = Query(-1_067_888_605, arrayOf("VesselTable"), driver, "VesselTable.sq", "getAllVessel", "SELECT VesselTable.id, VesselTable.name FROM VesselTable ORDER BY name ASC") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!
    )
  }

  public fun getAllVessel(): Query<VesselTable> = getAllVessel(::VesselTable)

  /**
   * @return The number of rows updated.
   */
  public fun insertVessel(id: String, name: String): QueryResult<Long> {
    val result = driver.execute(127_268_337, """
        |INSERT INTO VesselTable(id, name)
        |VALUES (?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   name=excluded.name
        """.trimMargin(), 2) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, name)
        }
    notifyQueries(127_268_337) { emit ->
      emit("VesselTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceVessel(id: String, name: String): QueryResult<Long> {
    val result = driver.execute(-631_603_729, """
        |INSERT OR REPLACE INTO VesselTable(id, name)
        |VALUES (?, ?)
        """.trimMargin(), 2) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, name)
        }
    notifyQueries(-631_603_729) { emit ->
      emit("VesselTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllVessel(): QueryResult<Long> {
    val result = driver.execute(1_873_856_234, """DELETE FROM VesselTable""", 0)
    notifyQueries(1_873_856_234) { emit ->
      emit("VesselTable")
    }
    return result
  }
}
